export default __webpack_public_path__ + "static/Hero-1-de2a321e5d6933ebca232922051b5a55.jpg";